exports = module.exports = require("../../../../react/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "puk-card{display:inline-block}puk-card[fluid]{width:100%}._18-{border-radius:22px;display:inline-block}._18-._1kA{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}._18-._2nt{box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}._18-._3aP{box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)}._18-._2nX{box-shadow:0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.22)}._18-._2iV{box-shadow:0 19px 38px rgba(0,0,0,.3),0 15px 12px rgba(0,0,0,.22)}._18-._2QO{background:#fff}._18-._2G0{background:var(--cyan-light)}._18-._3hD{background:var(--cyan)}._18-._2dF{background:var(--blue)}._18-.QIj{width:100%}", ""]);
// Exports
exports.locals = {
	"card": "_18-",
	"level-1": "_1kA",
	"level-2": "_2nt",
	"level-3": "_3aP",
	"level-4": "_2nX",
	"level-5": "_2iV",
	"basic": "_2QO",
	"light": "_2G0",
	"cyan": "_3hD",
	"blue": "_2dF",
	"fluid": "QIj"
};